import {createStore} from "vuex";
import {alert} from "@/store/alert.module";
import {auth} from "@/store/auth.module";
import {courseModule} from "@/store/course.module";
import {classModule} from "@/store/class.module";
import {sessionModule} from "@/store/session.module";
import {homeworkModule} from "@/store/homework.module";
import {projectModule} from "@/store/project.module";
import {schoolModule} from "@/store/school.module";
import {teacherModule} from "@/store/teacher.module";
import {ownerModule} from "@/store/owner.module";
import {studentModule} from "@/store/student.module";
import {examModule} from "@/store/exam.module";
import {questionBankModule} from "@/store/questionBank.module";
import {participationModule} from "@/store/participation.module";
import {fileModule} from "@/store/file.module";
import {shopModule} from "@/store/shop.module";
import {chatModule} from "@/store/chat.module";
import {ticketModule} from "@/store/ticket.module";
import {consultationModule} from "@/store/consultation.module";
import {consultantModule} from "@/store/consultant.module";
import {reviewerModule} from "@/store/reviewer.module";

const store = createStore({
    modules: {
        alert,
        auth,
        courseModule,
        classModule,
        sessionModule,
        homeworkModule,
        projectModule,
        schoolModule,
        ownerModule,
        teacherModule,
        studentModule,
        consultantModule,
        reviewerModule,
        examModule,
        questionBankModule,
        participationModule,
        fileModule,
        shopModule,
        chatModule,
        ticketModule,
        consultationModule,
    },
});
export default store;
